import React from 'react'
import { Button, Col, Row } from 'reactstrap'
import { TelephoneFill } from 'react-bootstrap-icons'
import { Link } from 'react-router-dom'

const ResponsiveHeader = () => {
    return (
        <div id='website-responsive'>
            <div className='display-block1'>
                <div className='flex-center'>
                    <a href='tel: (800) 442-1663' style={{ textDecoration: 'none' }}>
                        <TelephoneFill className='text-ss-primary fs-ss-20' />
                        <text className='px-2 border- border2 me-md3 fw-600 text-montserrat fs-ss-18-2' style={{ color: 'black', fontSize: '', }}> (800) 442-1663 </text>
                    </a>
                </div>
            </div>
            <section className="container-fluid display-block1">
                <div className="row justify-content-evenly align-items-center gy4">
                    <div className="col-lg-2 col-6 pb-1 justify-content-center flex-center ps-0">
                        <Link to='/toxicology-test-appointment' style={{ textDecoration: 'none' }}>
                            <Button className='btn-ss-secondary-header rounded20 mt-2 flex-cente' style={{ backgroundColor: '#ea1f25', width: '150px', justifyContent: 'center', boxShadow: '', display: 'flex', padding: '' }}>
                                <text className='text-montserrat fw-600 fs-ss-' style={{ fontSize: '11px', padding: '', }}>
                                    Book Toxicology Test
                                </text>
                            </Button>
                        </Link>
                    </div>
                    <div className="col-lg-2 col-6 pb-1 flex justify-content-center flex-center">
                        <Link to='/general-blood-test-appointment' style={{ textDecoration: 'none' }}>
                            <Button className='btn-ss-secondary-header rounded20 mt-2 flex-cente' style={{ backgroundColor: '#ea1f25', width: '150px', justifyContent: 'center', boxShadow: '', display: 'flex', padding: '' }}>
                                <text className='text-montserrat fw-600 fs-ss-' style={{ fontSize: '11px', padding: '', }}>
                                    Book Blood Test
                                </text>
                            </Button>
                        </Link>
                    </div>
                    <div className="col-lg-2 col-6 pb-1 ps-0 flex-center justify-content-center">
                        <Link to='/sti-std-test-appointment' style={{ textDecoration: 'none' }}>

                            <Button className='btn-ss-secondary-header rounded20 mt-2 flex-cente' style={{ backgroundColor: '#ea1f25', width: '150px', justifyContent: 'center', boxShadow: '', display: 'flex', padding: '' }}>
                                <text className='text-montserrat fw-600 fs-ss-' style={{ fontSize: '11px', padding: '', }}>
                                    Book STI/HIV Test
                                </text>
                            </Button>
                        </Link>

                    </div>
                    <div className="col-lg-2 col-6 pb-1 justify-content-center flex-center">
                        <Link to='/book-panel-test-appointment' style={{ textDecoration: 'none' }}>
                            <Button className='btn-ss-secondary-header rounded20 mt-2 flex-cente' style={{ backgroundColor: '#ea1f25', width: '150px', justifyContent: 'center', boxShadow: '', display: 'flex', padding: '' }}>
                                <text className='text-montserrat fw-600 fs-ss-' style={{ fontSize: '11px', padding: '', }}>
                                    Book Panel Test
                                </text>
                            </Button>
                        </Link>

                    </div>
                    <div className="col-lg-2 col-6 pb-3 justify-content-center flex-center">
                        <Link to='/book-covid-test-appointment' style={{ textDecoration: 'none' }}>
                            <Button className='btn-ss-secondary-header rounded20 mt-2 flex-cente' style={{ backgroundColor: '#ea1f25', width: '150px', justifyContent: 'center', boxShadow: '', display: 'flex', padding: '' }}>
                                <text className='text-montserrat fw-600 fs-ss-' style={{ fontSize: '11px', padding: '', }}>
                                    Book Covid Test
                                </text>
                            </Button>
                        </Link>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default ResponsiveHeader